import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  menuOpen = false;
  selectedItem = '';
  participationEnabled = true;
  private scrollY = 0;

  menuItens = [
    { nome: 'O PPA', path: 'ppa' },
    { nome: 'Planejar para construir', path: 'planning' },
    { nome: 'Agenda PPA', path: 'keep-up-with-ppa' },
    { nome: 'Plenárias', path: 'community-participation' },
  ];

  constructor(private router: Router) {}

  ngOnInit() {
    //   const agoraBrasil = new Date(
    //     new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
    //   );
    //   const ano = agoraBrasil.getFullYear();
    //   const mes = agoraBrasil.getMonth();
    //   const dataLimiteString = `${ano}-${String(mes + 1).padStart(2, '0')}-11T11:56:00`;
    //   const dataLimiteBrasil = new Date(
    //     new Date(dataLimiteString).toLocaleString('en-US', {
    //       timeZone: 'America/Sao_Paulo',
    //     })
    //   );
    //   this.participationEnabled = agoraBrasil < dataLimiteBrasil;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;

    if (this.menuOpen) {
      this.scrollY = window.scrollY;

      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      this.menuOpen = false;
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      window.scrollTo({ top: this.scrollY });
    }
  }

  activedItem(path: string): boolean {
    if (this.router.url === '/' && document.getElementById(path)) {
      return true;
    }

    return false;
  }

  navigate(path: string) {
    this.selectedItem = path;
    this.menuOpen = false;
    document.body.style.overflow = '';
    document.body.style.touchAction = '';

    if (path === 'agenda-ODS') {
      this.router.navigateByUrl('/ppa/agenda-ODS');
      return;
    }

    if (path === 'participacao') {
      this.router.navigateByUrl('/ppa/participacao');
      return;
    }

    this.router.navigateByUrl('/ppa').then(() => {
      setTimeout(() => {
        const element = document.getElementById(path);
        const headerOffset = 80;
        if (element) {
          const y =
            element.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    });
  }

  closeMenu() {
    this.menuOpen = false;
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
  }

  goHome() {
    this.menuOpen = false;
    this.selectedItem = '';
    document.body.style.overflow = '';
    document.body.style.touchAction = '';

    this.router.navigateByUrl('').then(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    });
  }

  @HostListener('document:click', ['$event'])
  outsideClick(event: Event) {
    const target = event.target as HTMLElement;
    const clickDentro =
      target.closest('.menu') || target.closest('.menu-toggle');
    if (!clickDentro) {
      this.closeMenu();
    }
  }
}
